import React from "react";
import { useLang } from "@/i18n";
import { Reveal, MaskedLineOnScroll } from "@/lib/motion";

const shots = [
  { src: "/images/p2.jpg", cls: "md:col-span-2 md:row-span-2 h-[280px] md:h-full", alt: "Satinatura manuale del metallo" },
  { src: "/images/p1.jpg", cls: "h-[220px] md:h-[300px]", alt: "Componente lucidato di precisione" },
  { src: "/images/p9.jpg", cls: "h-[220px] md:h-[300px]", alt: "Dettaglio lavorazione metallo" },
  { src: "/images/p5.jpg", cls: "h-[220px] md:h-[300px]", alt: "Lucidatura robotizzata" },
  { src: "/images/p7.jpg", cls: "h-[220px] md:h-[300px]", alt: "Finitura superficiale" },
  { src: "/images/p8.jpg", cls: "h-[220px] md:h-[300px]", alt: "Controllo qualità componente" },
  { src: "/images/p6.jpg", cls: "h-[220px] md:h-[300px]", alt: "Officina Olmi" },
];

export default function Gallery() {
  const { t } = useLang();
  return (
    <section id="work" data-testid="gallery-section" className="relative py-28 lg:py-40 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="mb-14 max-w-3xl">
        <Reveal>
          <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.work.overline}</span>
        </Reveal>
        <h2 className="mt-6 font-display text-4xl md:text-6xl font-medium tracking-tight text-white leading-none">
          <MaskedLineOnScroll>{t.work.title}</MaskedLineOnScroll>
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:auto-rows-[300px]">
        {shots.map((s, i) => (
          <Reveal key={i} delay={(i % 4) * 0.06} className={`group overflow-hidden clip-frame ${s.cls}`}>
            <img src={s.src} alt={s.alt} className="w-full h-full object-cover spotlight-img" data-testid={`gallery-img-${i}`} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
